<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <form @submit.prevent="saveCannedReply">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
                <div class="md:flex md:items-center md:justify-between">
                    <div class="flex-1 min-w-0">
                        <h1 class="py-0.5 text-2xl font-semibold text-gray-900">{{ $t('Create canned reply') }}</h1>
                    </div>
                </div>
            </div>
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="mt-6 shadow sm:rounded-sm">
                    <loading :status="loading"/>
                    <div class="bg-white md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
                        <div class="md:col-span-1">
                            <h3 class="text-lg font-medium leading-6 text-gray-900">{{ $t('Canned reply details') }}</h3>
                            <p class="mt-1 text-sm leading-5 text-gray-500">
                                {{ $t('Canned reply details and settings') }}.
                            </p>
                        </div>
                        <div class="mt-5 md:mt-0 md:col-span-2">
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="name">{{ $t('Name') }}</label>
                                    <div class="mt-1 relative rounded shadow-sm">
                                        <input
                                            id="name"
                                            v-model="cannedReply.name"
                                            :placeholder="$t('Name')"
                                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                            required
                                        >
                                    </div>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="shared">{{ $t('Shared') }}</label>
                                    <input-switch
                                        id="shared"
                                        v-model="cannedReply.shared"
                                        :disabled-label="$t('The canned reply is not shared')"
                                        :enabled-label="$t('The canned reply is shared')"
                                    ></input-switch>
                                    <div class="mt-2 relative text-xs text-gray-500">
                                        {{ $t('A shared saved answer, allows other users to use it') }}.
                                    </div>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="body">{{ $t('Body') }}</label>
                                    <input-wysiwyg
                                        id="body"
                                        v-model="cannedReply.body"
                                    ></input-wysiwyg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="stage-footer-surface text-right px-4 py-3 sm:px-6">
                        <div class="inline-flex">
                            <router-link
                                class="btn btn-secondary shadow-sm rounded mr-4"
                                to="/workspace/admin/settings/canned-replies"
                            >
                                {{ $t('Cancel') }}
                            </router-link>
                            <button
                                class="btn btn-gray shadow-sm rounded"
                                type="submit"
                            >
                                {{ $t('Create canned reply') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </main>
</template>

<script>
export default {
    name: "new",
    metaInfo() {
        return {
            title: this.$i18n.t('Create canned reply')
        }
    },
    data() {
        return {
            loading: false,
            cannedReply: {
                name: null,
                shared: true,
                body: '',
            },
        }
    },
    methods: {
        saveCannedReply() {
            const self = this;
            self.loading = true;
            axios.post('api/workspace/canned-replies', self.cannedReply).then(function (response) {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data saved correctly').toString(),
                    type: 'success'
                });
                self.$router.push('/workspace/admin/settings/canned-replies/' + response.data.cannedReply.id + '/edit');
            }).catch(function () {
                self.loading = false;
            });
        },
    }
}
</script>
